import { googleDrive } from "./google-drive";
import { oneDrive } from "./onedrive";
import type { Connector } from "./types";

export const CONNECTORS: Connector[] = [googleDrive, oneDrive];

export const configuredConnectors = (): Connector[] =>
    CONNECTORS.filter((connector) => connector.isConfigured);

export const forgetConnectorAccess = () => {
    for (const connector of CONNECTORS) connector.forget?.();
};

export { sourceOf } from "./provenance";
export type { ConnectorSource, FileSource } from "./provenance";
export { PickCancelled } from "./types";
export type { Connector } from "./types";
